import React from "react";
import "./UnlockAddonsModal.scss";

import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import Modal, {
  ModalScroller,
  ModalTitle,
} from "src/app/components/Modal/Modal";

interface Props {
  onClose: () => void;
  openSuccessModal: () => void;
}

function UnlockAddonsModal(props: Props) {
  const { onClose } = props;

  return (
    <Modal
      className="unlock-addons-modal"
      onClose={onClose}
      closeButtonText={
        <IDHFormattedMessage id="ws_cancel" defaultMessage="Cancel" />
      }
      displayCancelButton
      closeButtonVariant="white-with-black-border"
    >
      <ModalTitle>
        <IDHFormattedMessage
          id="ws_unlock_addons"
          defaultMessage="Unlock addons"
        />
      </ModalTitle>

      <ModalScroller maxHeight={647}>
        No unlock addons screen available
      </ModalScroller>
    </Modal>
  );
}

export default UnlockAddonsModal;
